import React from 'react';
import { Droplet, Mail, MapPin, Phone } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand Column */}
          <div className="md:col-span-1">
            <div className="flex items-center space-x-2 mb-4">
              <Droplet className="w-8 h-8 text-amber-400" />
              <h3 className="text-2xl font-bold">EGESEA</h3>
            </div>
            <p className="text-gray-400 leading-relaxed">
              Excellence in Edible Oils - Delivering premium quality products for over 25 years.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-amber-400">Quick Links</h4>
            <ul className="space-y-3">
              {['Home', 'Products', 'About', 'Contact'].map((item) => (
                <li key={item}>
                  <button
                    onClick={() => scrollToSection(item.toLowerCase())}
                    className="text-gray-400 hover:text-amber-400 transition-colors"
                  >
                    {item}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-amber-400">Our Products</h4>
            <ul className="space-y-3">
              <li className="text-gray-400">High Oleic Sunflower Oil</li>
              <li className="text-gray-400">Fatty Acid Distillate</li>
              <li className="text-gray-400">Vegetable Acid Oil</li>
              <li className="text-gray-400">Refined Edible Oils</li>
              <li className="text-gray-400">Extra Virgin Olive Oil</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-amber-400">Contact Info</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" />
                <a href="mailto:sales@egeseaou.ee" className="text-gray-400 hover:text-amber-400 transition-colors">
                  sales@egeseaou.ee
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" />
                <span className="text-gray-400">
                  Tallinn, Estonia
                </span>
              </li>
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" />
                <a href="tel:+3726991418" className="text-gray-400 hover:text-amber-400 transition-colors">
                  +372 699 1418
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-700">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {currentYear} EGESEA. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <button className="text-gray-400 hover:text-amber-400 transition-colors">
                Privacy Policy
              </button>
              <button className="text-gray-400 hover:text-amber-400 transition-colors">
                Terms of Service
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
